import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';

export default function Error404() {
  return (
    <>
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-auto">
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">Error 404</h4>
                    <p className="card-text">Página no encontrada, porfavor contactar con el desarrollador, gracias</p>
                </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
}